export const colors = {
  black01: '#000000',
  black02: '#232323',
  blackTransparency: 'rgba(0, 0, 0, 0.5)',
  blue01: '#001978',
  blue02: '#334793', // $blue-01 --> 80% opacity
  blue03: '#6675AE', // $blue-01 --> 60% opacity
  blue04: '#7F8CBB', // $blue-01 --> 50% opacity
  blue05: '#99A3C9', // $blue-01 --> 40% opacity
  blue06: '#CCD1E4', // $blue-01 --> 20% opacity
  blue07: '#E5E8F1', // $blue-01 --> 10% opacity
  blue08: '#F2F3F8', // $blue-01 --> 5% opacity
  blue09: '#63B9E4',
  blue10: '#0076a5',
  blue11: '#97d6de',
  blue12: '#e8eaf6',
  blue13: '#CDD1E0',
  blue14: '#808CBC',
  gold01: '#B59D6F',
  gray01: '#565656',
  gray02: '#999999',
  gray03: '#dedede',
  gray04: '#f4f4f4',
  gray05: '#4e4e52',
  gray06: '#D7D7D7',
  gray07: '#333333',
  gray08: '#dae1e7',
  gray09: '#e0e0e0',
  gray10: '#eeeeee',
  gray11: '#ABB8C3',
  gray12: '#E6E9F1',
  gray13: '#e2dff0',
  gray14: '#262626',
  gray15: '#F7F7F7',
  gray16: '#969696',
  gray17: '#B4B3B3',
  gray18: '#C9CAC9',
  gray50: '#FAFAFA',
  gray300: '#DDDCDC',
  gray600: '#717171',
  gray700: '#464646',
  gray900: '#050505',
  green01: '#417505',
  green02: '#679137', // $green-01 --> 80% opacity
  green03: '#8dac69', // $green-01 --> 60% opacity
  green04: '#a0ba82', // $green-01 --> 50% opacity
  green05: '#b3c89b', // $green-01 --> 40% opacity
  green06: '#d9e3cd', // $green-01 --> 20% opacity
  green07: '#ecf1e6', // $green-01 --> 10% opacity
  green08: '#f5f8f2', // $green-01 --> 5% opacity
  green09: '#3D7F4B',
  green10: '#f0f7ef',
  orange01: '#CF7700',
  orange02: '#e65f37',
  orange03: '#d5b33e',
  orange04: '#fff4e5',
  purple01: '#aa1978',
  purple02: '#7a95ff',
  purple03: '#6264A7',
  red01: '#D12D30',
  red02: '#d93549', // $red-01 --> 80% opacity
  red03: '#e36776', // $red-01 --> 60% opacity
  red04: '#e7808d', // $red-01 --> 50% opacity
  red05: '#ec9aa4', // $red-01 --> 40% opacity
  red06: '#f6ccd1', // $red-01 --> 20% opacity
  red07: '#fae5e8', // $red-01 --> 10% opacity
  red08: '#fdf2f3', // $red-01 --> 5% opacity
  red09: '#e90030', // Found search term
  red10: '#C43741', // Upload folders result
  white01: '#ffffff',
  yellow01: '#ffcf2B',
  yellow02: '#fae61e',
  main200: '#CCD1E4',
  main300: '#B2BAD6',
  main400: '#6170AB',
  main900: '#193085',
  seaGreen100: '#59AC85',
  seaGreen200: '#128851',
  seaGreen050: '#C8F9E2',
  persianRed100: '#E16668',
  persianRed050: '#FCDEDF',
  princentonOrange050: '#FFD092',
  byzantineBlue050: '#D9E1FC',
  byzantineBlue200: '#2E53D6',
  highlight200: '#D50057',
  saffron050: '#FFF2C2',
  saffron200: '#F0BC00'
}

export const fonts = {
  lfIconsFont: 'lf-font',
  primaryFont: 'MTTMilano, Lato, Arial, sans-serif',
  primaryFontBold: 'MTTMilano-Bold, Lato, Arial, sans-serif',
  primaryFontMedium: 'MTTMilano-Medium, Lato, Arial, sans-serif',
  secondaryFont: 'Arial, Helvetica, sans-serif',
  interFont: 'Inter'
}

export const corporate = {
  borderBottom: `1px solid ${colors.blue01}`,
  callToActionColor02: colors.gray05,
  callToActionColor: colors.yellow02,
  color05: colors.blue08,
  color10: colors.blue07,
  color20: colors.blue06,
  color40: colors.blue05,
  color50: colors.blue04,
  color60: colors.blue03,
  color80: colors.blue02,
  dialogBackgroundColor: 'rgba(35,35,35,.7)',
  disabledColor: colors.gray02,
  errorColor: colors.red01,
  errorColorLight: colors.red07,
  primaryColor: colors.blue01,
  primaryColorLight: colors.blue07,
  primaryFont: fonts.primaryFont,
  primaryFontBold: fonts.primaryFontBold,
  primaryFontMedium: fonts.primaryFontMedium,
  secondaryColor: colors.white01,
  secondaryFont: fonts.secondaryFont,
  selectionColor: colors.red06,
  successColor: colors.green01,
  warningColor: colors.saffron050,
  warningInfo: colors.byzantineBlue050,
  warningHigh: colors.princentonOrange050,
  warningCritical: colors.persianRed100,

  infoTrue: colors.seaGreen050,
  infoFalse: colors.persianRed050
}

export const alert = {
  info: {
    titleBackground: corporate.primaryColor
  },
  error: {
    titleBackground: corporate.selectionColor
  },
  warning: {
    titleBackground: corporate.warningColor
  }
}
